import InviteSpecialistForm from './invite-specialist-container';

export default InviteSpecialistForm;
